import { Component, OnInit, ViewChild } from '@angular/core';
import { IonContent } from '@ionic/angular';
import { BalanceModel } from 'src/app/models/balance-model';
import { AccountBalanceService } from 'src/app/services/balance/account-balance.service';
import { WithdrawalService } from 'src/app/services/cashier/withdrawal.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';

@Component({
  selector: 'app-total-withdrawals',
  templateUrl: './total-withdrawals.component.html',
  styleUrls: ['./total-withdrawals.component.scss'],
})
export class TotalWithdrawalsComponent implements OnInit {
  @ViewChild(IonContent) content: IonContent;

  public error = null;

  public accountBalances: BalanceModel;

  public totalWithdrawals: any[] = [];

  public emailMeDisabled: boolean = false;
  private defaultCurrency: string;
  public totalWithdrawalCount: number;
  public totalWithdrawalSum: number;

  constructor(
    private balanceService: AccountBalanceService,
    private config: ConfigService,
    private successMessageService: SuccessMessageService,
    private withdrawalService: WithdrawalService,
  ){}

  ngOnInit() {
    this.successMessageService.clearMessage();
    this.error = null;
    this.onGetBalance();
    this.onGetTotalWithdrawals();
  }

  onGetBalance() {
    this.balanceService.getBalance().subscribe(
      (balance: BalanceModel) => {
        this.defaultCurrency = balance.getDefaultCurrency();
        if (balance) {
          this.accountBalances = balance;
        }
      }
    );
  }

  onGetTotalWithdrawals() {
    this.totalWithdrawals = [];
    this.withdrawalService.callGetTotalWithdrawals().subscribe(
      (response: any) => {
        if (response && !!response.result) {
          var tempWithdrawals: any = response.payload;
          for (let index in tempWithdrawals) {
            this.totalWithdrawals.push(tempWithdrawals[index]);
          }
        }
        this.totalWithdrawalCount = this.totalWithdrawals.length;
        this.totalWithdrawalSum = this.totalWithdrawals.reduce((a, b) => a + (b.currency === this.defaultCurrency ? b['amount'] : 0), 0);
      },
      (error) => {
        this.successMessageService.clearMessage();
        this.content.scrollToTop();
        this.error = error;
        this.error.setErrorMessage('Sorry, an error occured processing your withdrawals. Please try again');
        console.error("Error on get withdrawals", error);
      }
    )
  }

  onEmailMeClicked() {
    this.emailMeDisabled = true;

    this.withdrawalService.callSendTotalWithdrawals().subscribe(
      (response) => {
        if (response.result == 1) {
          this.content.scrollToTop();
          this.successMessageService.setMessage("An email with all results has been sent.");
        }
      },
      (error) => {
        this.successMessageService.clearMessage();
        this.content.scrollToTop();
        this.error = error;
        this.error.setErrorMessage('Sorry, an error occured processing your report. Please try again');
      }
    )
  }
}
